import { IPatient, Patient } from './Patient';
import { Job } from './Job';

/**
 * create on demand object type it extends the patient Record but has an optional DoB and nhsNumber
 * These fields aren't required by onDemand but are by Patient.
 */

export interface IOnDemand extends Omit<IPatient, 'dateOfBirth' | 'nhsNumber'> {
    dateOfBirth?: string;
    age?: number;
    speciality?: string[];
    hcpPriceInPence?: number;
    priceInPence?: number;
    hcpSub?: string | null;
    hidePriceInApp?: boolean;
    nhsNumber?: string;
    blockSize?: string;
}

interface OnDemand extends IOnDemand {}

class OnDemand extends Job {
    static INITIAL_VALUES = {
        ...Job.INITIAL_VALUES,
        ...Patient.INITIAL_VALUES,
    };

    constructor(data: IOnDemand) {
        super(data);
        Object.assign(this, data);
    }
}

export { OnDemand };
